export const setPOPOUTTRUE = "setPOPOUTTRUE";
export const setPOPOUTFALSE = "setPOPOUTFALSE";
